import { createFileRoute } from '@tanstack/react-router';
import GalleryPage from '../../components/webdesigned/GalleryPage';
import WebDesignedPortal from '../../components/portals/WebDesignedPortal';

export const Route = createFileRoute('/webdesigned/gallery')({
  component: () => (
    <WebDesignedPortal>
      <GalleryPage />
    </WebDesignedPortal>
  ),
});
